export default "__VITE_ASSET__DoqmMccp__"